(() => {
  const init = () => {
    if (!document.querySelector('.product-page')) return;
    document.body.classList.add('haidar-product-page-ready');

    let pinchTarget = null;
    let startDistance = 0;
    let startScale = 1;
    let scale = 1;
    const distance = touches => Math.hypot(
      touches[0].clientX - touches[1].clientX,
      touches[0].clientY - touches[1].clientY
    );
    const eligibleImage = target => {
      const image = target && (target.tagName === 'IMG' ? target : target.closest && target.closest('img'));
      if (!image || !image.closest('.product-page') || image.closest('.sticky_add_to_cart')) return null;
      return image;
    };

    document.addEventListener('touchstart', event => {
      if (event.touches.length !== 2) return;
      const image = eligibleImage(event.target);
      if (!image) return;
      pinchTarget = image;
      startDistance = distance(event.touches);
      startScale = scale;
      pinchTarget.style.transition = 'none';
      pinchTarget.style.transformOrigin = 'center center';
    }, { passive: true });

    document.addEventListener('touchmove', event => {
      if (!pinchTarget || event.touches.length !== 2 || !startDistance) return;
      event.preventDefault();
      scale = Math.max(1, Math.min(3, startScale * distance(event.touches) / startDistance));
      pinchTarget.style.transform = 'scale(' + scale + ')';
    }, { passive: false });

    document.addEventListener('touchend', event => {
      if (!pinchTarget || event.touches.length >= 2) return;
      pinchTarget.style.transition = 'transform .25s ease';
      if (scale < 1.08) {
        scale = 1;
        pinchTarget.style.transform = '';
      }
      pinchTarget = null;
      startDistance = 0;
    }, { passive: true });

    let lastTap = 0;
    document.addEventListener('touchend', event => {
      const image = eligibleImage(event.target);
      if (!image) return;
      const now = Date.now();
      if (now - lastTap < 320) {
        scale = 1;
        image.style.transition = 'transform .25s ease';
        image.style.transform = '';
      }
      lastTap = now;
    }, { passive: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();